import React from 'react';
import { RadioButton, Txt } from '@vst/beam';

import styles from './SelectionCard.module.scss';

type SelectionCardProps = {
  checked: boolean;
  className?: string;
  labelRadioButton: string;
  onClickHandler: () => void;
  subtitle?: string;
  value: string;
};

export const SelectionCard: React.FC<SelectionCardProps> = ({
  labelRadioButton,
  subtitle,
  checked,
  onClickHandler,
  value,
}) => {
  return (
    <div
      data-cy="cardContainer"
      className={
        checked
          ? `${styles['containerAddressButtons']} ${styles['containerAddressButtonsChecked']}`
          : `${styles['containerAddressButtons']} ${styles['containerAddressButtonsUnChecked']}`
      }
    >
      <div className={styles['wrapper']}>
        <div data-cy="radioButton" onClick={onClickHandler}>
          <Txt data-cy="radioButtonLabel" variant="heading5" mb="16px">
            {labelRadioButton}
          </Txt>
          <div className={styles['radioButtonContainer']}>
            <RadioButton
              label={''}
              value={value}
              checked={checked}
              className={styles['radioButton']}
            />
            <Txt data-cy="addressLocation" variant="paragraphRegular">
              {subtitle}
            </Txt>
          </div>
        </div>
      </div>
    </div>
  );
};
